import ko from "../messagesJson/ko.json";
export const PartialMessages = {
    ko,
} as const;
